<template xmlns:v-hammer="http://www.w3.org/1999/xhtml">
  <div
    id="app"
    :class="{'mobile-fix-height': closeScroll, 'change-lang': rtlTextClass}"
  >
    <!--    v-hammer:swipe.horizontal="onSwipe"-->
    <app-header v-if="init && (!isMobile || ($route.meta && $route.meta.mobileHeader))" />
    <router-view />

    <div
      v-if="!init"
      class="spinner"
    >
      <div class="double-bounce1" />
      <div class="double-bounce2" />
    </div>

    <ad-block @passValue="adBlockDetector" />
    <using-ad-block v-if="init && adblockEnabled" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import AdBlock from 'vue-adblock';
import mutations from './store/temp/temp.mutationlist';
import mutations2 from './store/mutationlist';
import UsingAdBlock from './components/UsingAdBlock';
import AppHeader from './components/AppHeader';

export default {
  components: {
    AdBlock,
    UsingAdBlock,
    AppHeader,
  },

  data() {
    return {
      closeScroll: false,
      adblockEnabled: false,
    };
  },

  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      locale: state => state.locale,
      reverseTextForLocals: state => state.filters.reverseTextForLocals,
      menuRight: state => state.temp.menuRight.show,
      menuLeft: state => state.temp.menuLeft.show,
      init: (state) => {
        const loader = document.getElementById('main-loader');
        if (state.temp.init && loader) {
          loader.style.display = 'none';
        }
        return state.temp.init;
      },
    }),
    rtlTextClass() { return !!this.reverseTextForLocals.includes(this.locale); },
  },

  watch: {
    menuRight(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.closeScroll = !this.closeScroll;
      }
    },
    menuLeft(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.closeScroll = !this.closeScroll;
      }
    },
    rtlTextClass: {
      immediate: true,
      handler(reverse) {
        if (reverse && !document.body.classList.contains('revers-text')) {
          document.body.classList.add('revers-text');
        }

        if (!reverse && document.body.classList.contains('revers-text')) {
          document.body.classList.remove('revers-text');
        }
      },
    },
  },

  created() {
    // Detect mobile state and change on window resize (throttled)
    const checkAppMode = () => {
      const isMobile = window.innerWidth < 768;
      // only if there is a change to be done
      if (isMobile !== this.$store.state.isMobile) {
        this.$store.commit(mutations2.SET, { key: 'isMobile', value: window.innerWidth < 768 });
      }
    };
    window.addEventListener('resize', checkAppMode);
    checkAppMode();
  },

  mounted() {
    if (document.readyState) {
      setTimeout(() => { window.scroll(0, 0); }, 500);
    }
  },

  methods: {
    onSwipe(e) {
      switch (e.direction) {
        /* case: 4 is for DIRECTION_RIGHT */
        case 4:
          if (
            (Math.abs(e.overallVelocityX) > 0.5 &&
              Math.abs(e.overallVelocityY) < 0.5 &&
              Math.abs(e.deltaX) >= 100)
          ) {
            this.$store.commit(mutations.SWIPE_LEFT_EVENT, {
              direction: e.direction,
              srcEventX: e.srcEvent.x,
              srcEventY: e.srcEvent.y,
              centerX: e.center.x,
              type: e.type,
              distance: e.distance,
              deltaX: e.deltaX,
              deltaY: e.deltaY,
              isFirst: e.isFirst,
              isFinal: e.isFinal,
            });
          }
          break;
        case 8:
          // console.log(document.getElementsByClassName('wrap-container')
          // [0].scrollTop += Math.abs(e.deltaX));
          break;

        /* case: 2 is for DIRECTION_LEFT */
        case 2:
          this.$store.commit(mutations.SWIPE_RIGHT_EVENT, {
            direction: e.direction,
            srcEventX: e.srcEvent.x,
            srcEventY: e.srcEvent.y,
            centerX: e.center.x,
            type: e.type,
            distance: e.distance,
            deltaX: e.deltaX,
            deltaY: e.deltaY,
            isFirst: e.isFirst,
            isFinal: e.isFinal,
          });
          break;
        default :
          // eslint-disable-next-line no-console
          break;
      }
    },
    adBlockDetector(e) {
      this.adblockEnabled = e === 'detected';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue